import { Table, TableBodyInfiniteScroll } from '@library/components/table';
import { Loading } from '@library/components/Loading';
import { ResolutionFailuresRows } from '@bo-components/resolutions/resolutionDetails';
import type { TransformedResolutionFailures } from '@library/types/resolutions/resolutionDetails';
import { useMemo } from 'react';

export interface ResolutionDetailsSummaryTableProps {
  currentPage: number;
  failuresData: TransformedResolutionFailures;
  handleCurrentPageChange: () => void;
  isFailuresFetching: boolean;
  totalPages: number;
}

export const ResolutionDetailsSummaryTable = ({
  currentPage,
  failuresData,
  handleCurrentPageChange,
  isFailuresFetching,
  totalPages
}: ResolutionDetailsSummaryTableProps) => {
  const infiniteScrollProps = useMemo(
    () => ({
      dataLength: failuresData?.length ?? 0,
      hasMore: totalPages > currentPage,
      loader: <p>Loading...</p>,
      next: handleCurrentPageChange
    }),
    [failuresData?.length, currentPage, handleCurrentPageChange, totalPages]
  );

  if (isFailuresFetching) {
    return <Loading loadingMessage="Loading resolution failures." />;
  }

  return (
    <Table
      className="border-soFresh-140 flex max-w-[544px] grow flex-col items-start self-stretch rounded-md border"
      dataTestId="summary-error-list"
    >
      <div className="text-soClean-100 border-soFresh-130 bg-soFresh-110 flex h-12 items-center self-stretch rounded-md border-b px-8 text-sm">
        Error details
      </div>
      {failuresData.length === 0 && (
        <div className="border-soFresh-130 self-stretch border-b">
          <div className="text-soClean-100 bg-soFresh-110 mx-4 flex h-12 items-center px-4 text-xs">
            No errors
          </div>
        </div>
      )}
      <TableBodyInfiniteScroll
        bodyHeight="238px"
        bodyMaxHeight="max-h-[238px]"
        className="min-w-[544px]"
        infiniteScrollProps={infiniteScrollProps}
        scrollId="UnsettlementsTableBody"
      >
        {failuresData.map((failure, index) => (
          <ResolutionFailuresRows
            key={failure.newWagerId}
            rowData={failure}
            index={index}
          />
        ))}
      </TableBodyInfiniteScroll>
    </Table>
  );
};
